function Geo() {
  this.getLocation = function getLocation() {
    if (this.support()) {
      this.getPos(result => {
        return {
          lat: result.coords.latitude,
          long: result.coords.longitude
        };
      });
    }
  };
  this.distanceFromPos = function distanceFromPos(pos, lat, long) {
    let res = 1;
    if (pos) {
      res = this.distance(pos.lat, pos.long, lat, long, "K");
    }
    return res.toFixed(1);
  };

  this.support = function support() {
    return "geolocation" in navigator;
  };

  this.distance = function distance(lat1, lon1, lat2, lon2, unit) {
    var radlat1 = (Math.PI * lat1) / 180;
    var radlat2 = (Math.PI * lat2) / 180;
    var theta = lon1 - lon2;
    var radtheta = (Math.PI * theta) / 180;
    var dist =
      Math.sin(radlat1) * Math.sin(radlat2) +
      Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") {
      dist = dist * 1.609344;
    }
    if (unit == "N") {
      dist = dist * 0.8684;
    }
    return dist;
  };

  this.getPos = function getPos(success, error) {
    navigator.geolocation.getCurrentPosition(success, error);
  };
}
export const geo = new Geo();
